import React from "react";
import MetaTags from "react-meta-tags";

const baseUrl = "https://hayam.mx";

function GlobalSeo() {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Casa Hayam",
    url: baseUrl,
    logo: `${baseUrl}/assets/img/footer-logo.png`,
    sameAs: [
      "https://www.facebook.com/yourpage",
      "https://www.instagram.com/yourpage",
    ],
    contactPoint: [{
      "@type": "ContactPoint",
      telephone: "+52-1-5532231857",
      contactType: "customer service",
      areaServed: "MX",
      availableLanguage: ["en"]
    }]
  };

  const webSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Casa Hayam",
    url: baseUrl,
    potentialAction: {
      "@type": "SearchAction",
      target: `${baseUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <MetaTags>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(webSite)}</script>
    </MetaTags>
  );
}

export default GlobalSeo;